<template>
  <FullScreenPopup
    ref="popup"
    :title="getBannerTitle"
    :lock-scroll="true"
  >
    <div class="info-tile__content" :style="`background-color: ${getBackgroundColor}`">
      <a class="info-tile__block" :href="getBannerUrl" target="_blank">
        <img class="info-tile__image" :src="getBannerImage()" :alt="getBannerTitle" />
      </a>
    </div>
  </FullScreenPopup>
</template>

<script>
import moment from 'moment/moment';
import { mapGetters } from 'vuex';
import { Env } from '@/shared/config/environment';
import { FullScreenPopup } from '@/shared/ui/popup';

export default {
  props: {
    banner: {
      type: Object,
      default: () => {},
    },
  },
  components: { FullScreenPopup },
  computed: {
    ...mapGetters('layoutModule', ['isWideScreen', 'isDesktop', 'isTablet', 'isMobile']),
    isPublished() {
      if (!this.banner.publicationFrom || !this.banner.publicationTo) {
        return false;
      }

      return moment().isBetween(
        this.banner.publicationFrom,
        this.banner.publicationTo,
        null,
        '[]'
      );
    },
    getBannerTitle() {
      return this.banner.title;
    },
    getBannerUrl() {
      return this.banner.linkUA;
    },
    getBackgroundColor() {
      return `#${this.banner.color}`;
    },
  },
  methods: {
    open() {
      if (this.isPublished && this.getBannerImage()) {
        this.$refs.popup.open();
      }
    },
    close() {
      this.$refs.popup.close();
    },
    togglePopup() {
      this.$refs.popup.togglePopup();
    },
    getBannerImage() {
      if (this.isWideScreen && this.banner?.imgWide) {
        const img = this.banner?.imgWide;
        return `${Env.server.admin}/${img}`;
      } else if (this.isDesktop && this.banner?.imgDesktop) {
        const img = this.banner?.imgDesktop;
        return `${Env.server.admin}/${img}`;
      } else if (this.isTablet && this.banner?.imgTablet) {
        const img = this.banner?.imgTablet;
        return `${Env.server.admin}/${img}`;
      } else if (this.isDesktop && this.banner?.imgAdaptive) {
        const img = this.banner?.imgAdaptive;
        return `${Env.server.admin}/${img}`;
      } else {
        const img = this.banner?.imgDesktop || this.banner?.imgTablet || this.banner?.imgAdaptive || '';
        return `${Env.server.admin}${img}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.info-tile {
  &__content {
    display: flex;
    width: 100%;
  }

  &__block {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  &__image {
    height: 100%;
    object-fit: contain;
  }
}

::v-deep .fullscreen-popup__content-wrapper {
  max-height: 100% !important;
}
</style>
